module.exports = __webpack_public_path__ + "static/img/particle.c2df37ba.png";